import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
// Fetch all taxes
export const fetchUnits = createAsyncThunk('units/fetchUnits', async (id) => {
    const response = await axios.get(`${API_URL}/accounting/units/${id}`);
    // console.log(response);
    return response.data;
});

// Create a new tax
export const createUnit = createAsyncThunk('units/createUnit', async (taxData) => {
    const company = JSON.parse(localStorage.getItem('company'));
    const response = await axios.post(`${API_URL}/accounting/units`, {
        company_id: company.company?.id,
        name: taxData.name,
    });
    return response.data;
});

// Update an existing tax
export const updateUnit = createAsyncThunk('units/updateUnit', async ({ id, taxData }) => {
    const response = await axios.put(`${API_URL}/accounting/units/${id}`, taxData);
    return response.data;
});

// Delete a tax
export const deleteUnit = createAsyncThunk('units/deleteUnit', async (id) => {
    await axios.delete(`${API_URL}/accounting/units/${id}`);
    return id;
});

// Initial State
const initialState = {
    units: [],
    loading: false,
    error: null
};

export const unitSlice = createSlice({
    name: 'units',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            // Fetch taxes
            .addCase(fetchUnits.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUnits.fulfilled, (state, action) => {
                state.loading = false;
                state.units = action.payload.data;
            })
            .addCase(fetchUnits.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Create tax
            .addCase(createUnit.fulfilled, (state, action) => {
                state.units.push(action.payload.data);
            })

            // Update tax
            .addCase(updateUnit.fulfilled, (state, action) => {
                const index = state.units.findIndex(tax => tax.id === action.payload.data.id);
                if (index != -1) {
                    state.units[index] = action.payload.data;
                }
            })

            // Delete tax
            .addCase(deleteUnit.fulfilled, (state, action) => {
                state.units = state.units.filter(tax => tax.id !== action.payload);
            });
    }
});

export default unitSlice.reducer;
